import React from 'react';
import { Spinner as RSSpinner } from 'reactstrap';

import './styles.scss';

const Spinner = ({ pageLoading, tableLoading, ...props }) => {
  const wrapperClass = `spinner-wrappers ${pageLoading || tableLoading ? 'spinner-wrapper-page-loading' : ''}`;

  return (
    <div className={wrapperClass} {...props}>
      <RSSpinner color="danger" />
    </div>
  );
};

export default Spinner;
